export default __webpack_public_path__ + "static/media/Bruno-Marques-resume.7424cdeb.pdf";